import { LANGUAGES } from '@/enums/general';
import store from '@/store';

export default {
    install (Vue) {
        Vue.mixin({
            beforeRouteEnter (to, from, next) {
                next((vm) => {
                    vm.setTitle(to.meta.title);
                });
            },
            methods: {
                /**
                 * Only allows number input (digits and dot).
                 * @param {object} e
                 * @return {boolean}
                 */
                onlyNumber (e) {
                    e = e || window.event;
                    const charCode = (e.which) ? e.which : e.keyCode;
                    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
                        e.preventDefault();
                        if (charCode === 44) {
                            // Comma entered. Fill in a dot (.)
                            e.target.value = `${e.target.value}.`;
                        }
                    } else {
                        return true;
                    }
                },

                /**
                 * Convenience function that changes a 'loading' parameter using the results of a promise.
                 * @param {Promise} promise
                 * @returns {Promise}
                 */
                wrapLoading (promise) {
                    this.loading = true;
                    return promise.then(() => {
                        this.loading = false;
                    }).catch((err) => {
                        this.loading = false;
                        throw err;
                    });
                },
                /**
                 * Check if a specific module is enabled, by looking in the enabled_modules global.
                 * @param {string} name
                 * @returns {boolean}
                 */
                modEnabled (name) {
                    if (!store.state.user.modules) {
                        return false;
                    }
                    const modules = store.state.user.modules;
                    return Object.prototype.hasOwnProperty.call(modules, name) && modules[name];
                },
                /**
                 * Set page title prefix.
                 * @param {string} title
                 */
                setTitle (title) {
                    const companyName = store.state.systemStatus.tenant_name ?? 'Inserve';
                    document.title = `${(title ? (`${title} - `) : '') + companyName} Portal`;
                    if (import.meta.env.DEV) {
                        document.title = `🔴 DEVELOPMENT - ${document.title}`;
                    }
                },
                getLang (lang) {
                    return LANGUAGES[lang];
                },
                getLanguages () {
                    return Object.keys(LANGUAGES).map((key) => {
                        return { id: key, label: LANGUAGES[key] };
                    });
                },
                /**
                 * Helper to generate int between min and max.
                 * @param min
                 * @param max
                 * @returns {number}
                 */
                randomBetween (min, max) {
                    return Math.floor(Math.random() * (max - min + 1) + min);
                },
                formatSize (bytes, decimals = 2) {
                    if (bytes === 0) {
                        return '-';
                    }

                    const k = 1024;
                    const dm = decimals < 0 ? 0 : decimals;
                    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                    const i = Math.floor(Math.log(bytes) / Math.log(k));

                    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
                },
            },
        });
    },
};
